import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from "@solomon-labs/design/components/ui";
import React from "react";

/**
 * Why a disabled control is disabled, on hover or focus of the control
 * itself. A disabled DS button takes no pointer events and no focus, so the
 * wrapper is the tooltip trigger: it is focusable and names the control and
 * the reason for assistive tech. Without a reason it renders the control
 * alone. The console's "state always, reasons on demand". Same as the
 * Distributor Console's (yaas-issuer `pages/Clients/DisabledReason`).
 */
export function DisabledReason({
    reason,
    label,
    children
}: {
    reason: string | null;
    /** The control's name, read with the reason. */
    label: string;
    children: React.ReactElement;
}): React.ReactElement {
    if (!reason) return children;
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger
                    tabIndex={0}
                    aria-label={`${label}: ${reason}`}
                    render={<span className="inline-flex" />}
                >
                    {children}
                </TooltipTrigger>
                <TooltipContent side="top">{reason}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
